export const EDITABLEELEMENT_VARIANT_DEFAULT = 'default'
export const EDITABLEELEMENT_VARIANT_DANGER = 'danger'
